import { Warning } from "../alert";
import { Link } from "../link";

export const StreamingCutoverWarning = () => (
  <Warning>
    <Link variant="inline" href={"/events/event-streaming"}>
      Event streaming
    </Link>{" "}
    destinations don't dual-run. Because streaming events bypass the warehouse and
    go straight to the destination, running both your previous tool and Hightouch
    streaming at the same time sends duplicate events. Turn on the Hightouch
    streaming destination and turn off your previous tool's streaming destination at
    the same time.
  </Warning>
);
